/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Preflight_FailedInputs */

const en_orders_carrier_preflight_failed = /** @type {(inputs: Orders_Carrier_Preflight_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShipPeek preflight failed. Update address/date and retry.`)
};

const es_orders_carrier_preflight_failed = /** @type {(inputs: Orders_Carrier_Preflight_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo la validacion previa de ShipPeek. Actualiza direccion o fecha e intenta de nuevo.`)
};

/**
* | output |
* | --- |
* | "ShipPeek preflight failed. Update address/date and retry." |
*
* @param {Orders_Carrier_Preflight_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_preflight_failed = /** @type {((inputs?: Orders_Carrier_Preflight_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Preflight_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_preflight_failed(inputs)
	return es_orders_carrier_preflight_failed(inputs)
});